/* @flow */
import * as React from 'react';

const REFRESH_MS = 500;

type Props = {
  start: Date,
};

type State = {
  elapsed: number,
};

class Timer extends React.Component<Props, State> {
  state: State = {
    elapsed: this.getElapsedMiliseconds(),
  };

  componentDidMount() {
    this.timer = setInterval(this.tick, REFRESH_MS);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  timer: IntervalID;

  tick = () => {
    this.setState({ elapsed: this.getElapsedMiliseconds() });
  };

  getElapsedMiliseconds(): number {
    return new Date() - this.props.start;
  }

  render() {
    const minutes = Math.floor(this.state.elapsed / 60000);
    const seconds = ((this.state.elapsed % 60000) / 1000).toFixed(0);

    return <span>{minutes + ':' + (Number(seconds) < 10 ? '0' : '') + seconds}</span>;
  }
}

export default Timer;
